export default "__VITE_ASSET__BWjqHnMc__"